// extracted by mini-css-extract-plugin
export default {"main":"Content_main__AeZzD"};